import React, { useEffect, useState } from 'react'
import SweetAlert from 'react-bootstrap-sweetalert';


import 'ag-grid-enterprise';
import 'ag-grid-enterprise/styles/ag-grid.css'; // Core grid CSS, always needed
import 'ag-grid-enterprise/styles/ag-theme-balham.css';
import redirectURL from "../redirectURL";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

import 'react-datetime/css/react-datetime.css';
import Datetime from 'react-datetime';
import moment from "moment";
import { getHyphenYYYYMMDDHHMMSS, getDDMMMYYYY, getHyphenYYYYMMDD, getHyphenDDMMYYYY } from '../common/utils';

var decipher = salt => {
    const textToChars = text => text.split('').map(c => c.charCodeAt(0));
    const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);
    return encoded => encoded.match(/.{1,2}/g)
        .map(hex => parseInt(hex, 16))
        .map(applySaltToChar)
        .map(charCode => String.fromCharCode(charCode))
        .join('');
}
var decode = decipher("Z744cRBHYjQTsI6cOlNaUKbuEQF6MiEr");
var localStorageRole = (localStorage.getItem("role"))


const TrackingCompletionDashboard = () => {

    var [rowData, setrowData] = useState([]);
    var [overly, setoverly] = useState('show-n')
    const [tableHeaders, setTableHeaders] = useState(['Date']); // Initialize with 'Date'
    var [loadshow, setloadshow] = useState('show-n');
    // const [selectedDate, setSelectedDate] = useState(new Date());
   

    var [show, setshow] = useState(false)
    var [basicTitle, setbasicTitle] = useState('')
    var [basicType, setbasicType] = useState('')
    var [from_date,setfrom_date] = useState( moment().format('DD-MM-YYYY'))
    var [end_date,setend_date] = useState( moment().add(2, 'days').format('DD-MM-YYYY'))
    var [category, setCategory] = useState()
    var [total, setTotal] = useState()
    var [gps, setGps] = useState()

    var [noGps, setNoGps] = useState()

    const options = {
        chart: {
            type: 'column',
            height: 250
        },
        title: {
            text: '',
            align: 'left'
        },
        xAxis: {
            categories: ["FTL", 'PTL'],
            crosshair: true
        },
        yAxis: {
            min: 0,
            // max:1400,
            title: {
                text: "Shipments Tracking %"
            },
            labels: {
                formatter: function () {
                    return this.value
                }
            },
            // tickInterval: 200,
        },
        tooltip: {
            valueSuffix: ''
        },
        plotOptions: {
            column: {
                // pointPadding: 0.1,
                borderWidth: 0,
                dataLabels: {
                    enabled: true,  // Enable data labels
                    allowOverlap:true,
                    //  formatter: function(){
                    //     if (this.y >= 1000000){
                    //         return (this.y / 1000000).toFixed(1) + 'M';
                    //     }
                    //     if (this.y >= 1000 ){
                    //         return (this.y /1000).toFixed(1)+ 'K';
                    //     }
                    //     return this.y;
                    // },
                    inside: false,  // Set to false to display labels outside the bar
                    style: {
                        color: 'black',  // Set text color, change as needed
                        textOutline: 'none'  // Remove or adjust the text outline
                    },
                    align:'center',
                    verticalAlign:'bottom',
                    y:-10,
                    x:0
                }
            },
        },
        colors: ["#1cc88a","#FF5370"],
        series: [
           
            {
                name: 'Tracking',
                data: gps, 
                pointPlacement:-0.05
            },
            {
                name: 'NO Tracking',
                data: noGps, 
                pointPlacement:-0.05
            },

        ],
        credits:{
            enabled:false
        }
    };
    useEffect(() => {
        getData();
    }, [])
   
    const getData = () => {
        setloadshow('show-m')
        var params ={}
        var location_name = localStorage.getItem("location");
        location_name = (location_name && location_name !=="undefined" && location_name !==null) ? location_name.split(",").filter(Boolean) : [];
        var locationNameConversion = location_name.map(e => e.trim().toLowerCase());
        var entity1 = localStorage.getItem("entity")
      entity1 = (entity1 && entity1 !== "undefined" && entity1.trim() !== "" && entity1 !== null) 
      ? entity1.split(",").map(x => x.trim()).filter(Boolean) 
      : [];    
      var entityConversion = entity1.map(e=> e.trim().toLowerCase())    // if(decode(localStorageRole).toLowerCase() === "user"){
            // if(decode(localStorageRole).toLowerCase() === "user"){
            if (
                locationNameConversion &&
                locationNameConversion.length > 0 &&
                !["all numeric shipments", "all sites", "all shipment"].some((item) => locationNameConversion.includes(item))
                    ) {                params.consigner_code = locationNameConversion
                // params.consignee_code = location_name
                  }
                  if(entityConversion && entityConversion.length > 0 && !["all"].some((item)=> entityConversion.includes(item))){
                    
                    params.truck_seal_entity = entityConversion
                }
      
        redirectURL.post('/consignments/gettrackingcompletion', params).then((resp) => {
            try {
                var data = resp.data;
                // console.log(data, "data");
        
                // Extract the categories
                // var records1 = Object.keys(data);
                setCategory(['FTL', 'PTL']);  // Categories for the x-axis
        
                var ftlGpsPercent = parseFloat((((data.ftlActiveRecords - data.ftlNoGps) / data.ftlActiveRecords) * 100).toFixed(2));
                var ptlGpsPercent = parseFloat((((data.ptlActiveRecords - data.ptlNoGps) / data.ptlActiveRecords) * 100).toFixed(2));
                
                var ftlNoGpsPercent = parseFloat((((data.ftlNoGps) / data.ftlActiveRecords) * 100).toFixed(2));
                var ptlNoGpsPercent = parseFloat((((data.ptlNoGps) / data.ptlActiveRecords) * 100).toFixed(2));
                


             
                var Gps = [ftlGpsPercent, ptlGpsPercent]
                var NoGps =[ftlNoGpsPercent, ptlNoGpsPercent]

                // console.log(Gps, "Gps");
                // console.log(NoGps, "NoGps");
                

                // // Set the data for each series
                setGps(Gps);
                setNoGps(NoGps);
        
             
        
            } catch (e) {
                setrowData([]);
                console.error('Error:', e);
            } finally {
                setTimeout(() => {
                    setloadshow('show-n');
                }, 3000);
            }
        }).catch(error => {
            console.error('Fetch error:', error);
            setrowData([]);
            setTimeout(() => {
                setloadshow('show-n');
            }, 3000);
        });
        

    }
    // console.log(category, "category")
    const onClickHideAll = () => {
        setloadshow('show-n')
    }

   
    var closeAlert = () => {
        setshow(false)
        setloadshow('show-n')
    }
   
    // const filterDatafordates = () => {
    //     // setloadshow('show-m')
    //     var from_date1 = from_date
    //     var to_date1 = end_date
    //     var from_date2 = from_date
    //     var to_date2 = end_date
        
        
    //     if (from_date1=="Invalid date"){
    //       from_date1 = '';
    //   }
    //   if (to_date1 =='Invalid date'){
    //       to_date1 = '';
    //   }
      
    //   if (from_date1 !=''){
    //       const dateObj = moment(from_date1, 'DD-MM-YYYY');
    //       const formattedFromDate = dateObj.toDate();
    //       from_date1= formattedFromDate;
    //   }
    //   if (to_date1 !=''){
    //       const dateObj = moment(to_date1, 'DD-MM-YYYY');
    //       const formattedFromDate = dateObj.toDate();
    //       to_date1= formattedFromDate;
    //   }
    //     if (from_date1 != '' && from_date1 != undefined && from_date1 != null && to_date1 != '' && to_date1 != undefined && to_date1 != null) {
    //         if (from_date1 <= to_date1) {
    //            getData(from_date2, to_date2)
    //             // setselectedData(filteredData)
    //             // setloadshow('show-n')
  
    //         }
    //           else{
    //               setbasicTitle('From Date sholud be less than To Date')
    //               setbasicType('danger')
    //               setoverly('show-n')
    //               setshow(true)
    //           }
    //       }
    //       else {
    //           setbasicTitle('Please Select Start Date and End date')
    //           setbasicType('danger')
    //           setoverly('show-n')
    //           setshow(true)
    //       }
    //   }
    // const handleDatesSelected = (e) => {
    //     const date = moment(e).format('DD-MM-YYYY');
    //     setfrom_date(date)
    // };
    // const handleDatesSelected1 = (e) => {
    //     const date = moment(e).format('DD-MM-YYYY');
    //     setend_date(date)
    // };
    return (
        <>
            <SweetAlert
                show={show}
                type={basicType}
                title={basicTitle}
                onConfirm={closeAlert}
            >
            </SweetAlert>
            <div className='card-header2'>
                <div className='d-flex justify-content-between'>
                    <h1 className='heading3 mt-20p ml-5p' style={{ width: "240px" }}>Tracking Completion %</h1>
                    {/* <div className='d-flex'>
                      
                        <div className="row">

                            <div className="form-group col-xl-4 col-lg-4">
                                <div>
                                    <label className='dateStyling'> From Date </label>
                                    <Datetime
                                        className='smaller-datetime'
                                        key={from_date}
                                        // onKeyDown ={(e)=> restrictToOther(e)}
                                        placeholder="Date"
                                        disableCloseOnClickOutside={false}
                                        closeOnSelect={true}
                                        name="from_date"
                                        inputProps={{ readOnly: 'true' }}
                                        value={from_date}
                                        dateFormat="DD-MM-YYYY"
                                        id='from_date'
                                        timeFormat={false}

                                        onChange={(e) => handleDatesSelected(e)}
                                        required />
                                </div>
                            </div>
                            <div className="form-group col-xl-4 col-lg-4">
                                <div>
                                    <label className='dateStyling'> To Date </label>
                                    <Datetime
                                        className='smaller-datetime'
                                        key={end_date}
                                        placeholder="Date"
                                        disableCloseOnClickOutside={false}
                                        closeOnSelect={true}
                                        name="to_date"
                                        inputProps={{ readOnly: 'true' }}
                                        value={end_date}
                                        dateFormat="DD-MM-YYYY"
                                        id='to_date'
                                        timeFormat={false}
                                        onChange={(e) => handleDatesSelected1(e)}
                                        required />
                                </div>
                            </div>
                            <div className="form-group col-xl-4 col-lg-4">
                                <button className="custom-btn1 f10 label label-success mt-30p" onClick={filterDatafordates}>Submit</button>
                            </div>
                        </div>
                    </div> */}

                </div>
                <HighchartsReact highcharts={Highcharts} options={options} />


            </div>
            <div className={"dataLoadpage1 " + (loadshow)}>
            </div>
            <div className={"dataLoadpageimg " + (loadshow)}>
                <div className="loader-box"><div className="loader-box"><div className="loader"></div></div></div>
            </div>
            <div className={"overlay-part " + (overly)} onClick={onClickHideAll}></div>
        </>

    )
}

function formatDate(dateString) {
    // Split the date string into components
    const parts = dateString.split('-');
    const day = parts[0];
    const month = parts[1];
    const year = parts[2];

    // Reformat the date string
    const newDateString = `${year}-${month}-${day}`;
    return newDateString;
}

export default TrackingCompletionDashboard;